module.exports = __webpack_public_path__ + "assets/images/ert_sports1.a8c7c3dfba8a691e7159512aff6fe525.png";